// frontend/src/services/healthService.js
import axios from 'axios';

/**
 * Check if the backend server is healthy and ready to accept requests.
 * This function is used during cold start to determine when the backend is available.
 *
 * @returns {Promise<boolean>} - Returns true if backend is healthy, false otherwise
 */
export const checkBackendHealth = async () => {
    try {
        // Get the API URL from environment, with fallbacks
        const apiUrl = process.env.REACT_APP_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:5001';

        // Strip /api suffix if present and append /health
        const baseUrl = apiUrl.replace(/\/api\/?$/, '');
        const healthUrl = `${baseUrl}/health`;

        // Make a GET request with a 5-second timeout
        const response = await axios.get(healthUrl, {
            timeout: 5000,
        });

        // Return true only if we get a 200 status
        return response.status === 200;
    } catch (error) {
        // Network errors, timeouts, or non-200 responses all return false
        return false;
    }
};
